import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import VorratsPage from "@/pages/VorratsPage";
import CalculatorPage from "@/pages/CalculatorPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PortalLayout from "@/pages/portal/PortalLayout";
import AdminLayout from "@/pages/admin/AdminLayout";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import DownloadsPage from "@/pages/DownloadsPage";
import WieFunktioniertPage from "@/pages/WieFunktioniertPage";
import PreislistePage from "@/pages/PreislistePage";
import EmpfehlungsPage from "@/pages/EmpfehlungsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/leistungen" element={<ServicesPage />} />
              <Route path="/vorratsgesellschaften" element={<VorratsPage />} />
              <Route path="/rechner" element={<CalculatorPage />} />
              <Route path="/ueber-uns" element={<AboutPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/portal/*" element={<PortalLayout />} />
              <Route path="/admin/*" element={<AdminLayout />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/downloads" element={<DownloadsPage />} />
              <Route path="/so-funktionierts" element={<WieFunktioniertPage />} />
              <Route path="/preisliste" element={<PreislistePage />} />
              <Route path="/empfehlen" element={<EmpfehlungsPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <CookieBanner />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
